import { Chat } from '../../types'

export function getChatsWithUnreadMessages(chats: Chat[], status: 'chats_with_unread_messages') {
  if (status !== 'chats_with_unread_messages') return []
  return chats?.filter(chat => chat.unreadMessagesCount > 0) || []
}
